/**
 * Local testing switch — not environment-driven, so it stays out of .env.
 * true  = the real Potato OAuth flow (default).
 * false = skip login entirely and sign in as a static local user.
 */
export const AUTH_ENABLED = true;
